<mat-toolbar>
  <span>Gestion des comptes</span>
  <span class="spacer"></span>
  @if (activiteAdherent === "gpo") {
    <app-filiale-selector></app-filiale-selector>
  }
  <app-officine-selector type="GestionComptes"></app-officine-selector>
</mat-toolbar>

@if (activiteAdherent === "gpo" && !selectedFiliale) {
  <div class="selection-message">Sélectionnez une filiale</div>
} @else if (!selectedAdherent) {
  <div class="selection-message">Sélectionnez un adhérent</div>
} @else {
  <mat-tab-group
    (selectedTabChange)="tabChanged($event)"
    animationDuration="0ms"
    class="remove-border-bottom"
    color="accent"
    fitInkBarToContent
    mat-stretch-tabs="false"
  >
    <mat-tab [label]="'UTILISATEURS'">
      @if (activeTab === 0) {
        <app-utilisateurs></app-utilisateurs>
      }
    </mat-tab>
    <mat-tab [label]="'DEMANDES'">
      @if (activeTab === 1) {
        <app-demandes></app-demandes>
      }
    </mat-tab>
  </mat-tab-group>
}
